import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const ingredientsStore = {
    actionCreators,
    reducer,
};

export default ingredientsStore;
